
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';

const MainNavbar = () => {
  const [open, setOpen] = useState(false);

  const menuItems = [
    { to: '/', label: 'Главная' },
    { to: '/about', label: 'О нас' },
    { href: '/#products', label: 'Каталог' },
    { to: '/music', label: 'Музыка' },
    { href: '/#contact', label: 'Контакты' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-header-bg py-6">
      <div className="container mx-auto px-4">
        <nav className="flex justify-center items-center relative">
          <Link to="/">
            <img 
              src="/images/logo.webp" 
              alt="Логотип BUDNIK Bee Garden"
              width="48"
              height="48"
              className="h-12 w-auto cursor-pointer hover:opacity-80 transition-opacity"
            />
          </Link>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button aria-label="Открыть меню" className="absolute right-0 text-[hsl(var(--menu-text))] transition-transform duration-300 hover:scale-110">
                <div className={`transition-transform duration-300 ${open ? 'rotate-180' : 'rotate-0'}`}>
                  {open ? <X className="h-6 w-6 text-[hsl(var(--menu-text))]" /> : <Menu className="h-6 w-6" />}
                </div>
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-header-bg border-none">
              <ul className="flex flex-col space-y-6 mt-8">
                {menuItems.map((item) => (
                  <li key={item.label}>
                    {item.to ? (
                      <Link 
                        to={item.to} 
                        className="text-[hsl(var(--menu-text))] hover:opacity-80 transition-colors text-lg"
                        onClick={() => setOpen(false)}
                      >
                        {item.label}
                      </Link>
                    ) : (
                      <a 
                        href={item.href} 
                        className="text-[hsl(var(--menu-text))] hover:opacity-80 transition-colors text-lg"
                        onClick={() => setOpen(false)}
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </SheetContent>
          </Sheet>
        </nav>
      </div>
    </header>
  );
};

export default MainNavbar;
